/**
 * Phase 40 — gateway LANES (user, 13/10/2026: "each gateway row gets its own
 * sender IDs and its own AI sender prompt; the same gateway may sit in the
 * pool twice, but only with different sender IDs"). A pool row IS a lane:
 * one gateway (routeId) plus the senders its drops send with. Two lanes may
 * share a gateway when their senders differ; the same senders twice is
 * refused (useless). Lane ids are strings (≤ 40, letters / digits / _ : -):
 * the editor mints uuids, a legacy row gets the deterministic `r<routeId>`
 * so kept RANDOM draws and drop→lane links survive the first read.
 * For Media Devoted | Created By Ciro Autiero
 */
export const DROP_GEN_LANE_ID_MAX = 40;
export const DROP_GEN_LANE_ID = /^[A-Za-z0-9_:-]{1,40}$/;
/** The block row's lane for "the whole gateway" (a rule or Phase 39's gateway source). */
export const DROP_GEN_ROUTE_BLOCK_LANE = "*";

export interface DropGenLaneSenders {
  /** The lane's own sender IDs (1–11 letters or digits each); [] = AI names only. */
  ids: string[];
  /** The AI sender prompt group this lane uses; null = the container's default group. */
  aiGroupId: string | null;
  /** Ordered prompt groups; null inherits the container. Legacy aiGroupId is read when absent. */
  aiGroupIds?: string[] | null;
  /** Reuse saved IDs without runtime AI, even when the container uses ALWAYS. */
  staticOnly?: boolean;
  /** Per-gateway settings; absent values keep legacy container defaults. */
  amount?: number;
  mode?: "SHARED" | "UNIQUE";
  aiMode?: "FALLBACK" | "ALWAYS";
}

export interface DropGenGatewayLane {
  id: string;
  routeId: number;
  weight: number | null;
  /** SMS a day through THIS lane (counted across the country); null = no cap. */
  capacity: number | null;
  senders: DropGenLaneSenders;
}

/** A stored pool row as it may arrive (the lane shape; `senders` absent on a legacy Phase 27 row). */
export interface DropGenGatewayLaneRow {
  id?: string;
  routeId: number;
  weight?: number | null;
  capacity?: number | null;
  senders?: { ids?: unknown; aiGroupId?: unknown; aiGroupIds?: unknown; staticOnly?: unknown; amount?: unknown; mode?: unknown; aiMode?: unknown } | null;
}
